// Fair-use soft cap banner text (ADR-0021 point 3). Alert only: Prego never slows down downloads.
import type { TenantDetail } from "../api/types";
import { atLeast } from "./roles";

export interface SoftCapNotice {
  level: 80 | 100;
  percent: number;
  text: string;
}

/** Returns the banner for owners and admins at 80 % or more of the soft cap, or null. */
export function softCapNotice(tenant: TenantDetail): SoftCapNotice | null {
  const u = tenant.usage;
  if (!u || !atLeast(tenant.role, "admin")) return null;
  if (!(u.soft_cap_bytes > 0) || !(u.download_bytes >= 0)) return null;
  if (u.download_bytes < 0.8 * u.soft_cap_bytes) return null;
  // Round down, so the text never says 100 % before the cap is reached.
  const percent = Math.floor((u.download_bytes / u.soft_cap_bytes) * 100);
  if (u.download_bytes >= u.soft_cap_bytes) {
    return {
      level: 100,
      percent,
      text:
        `Downloads this month (${u.month}) are at ${percent} % of the fair-use soft cap. ` +
        "The soft cap is reached. Prego does not slow down downloads. Contact us to talk about your use.",
    };
  }
  return {
    level: 80,
    percent,
    text:
      `Downloads this month (${u.month}) are at ${percent} % of the fair-use soft cap. ` +
      "Prego does not slow down downloads. Contact us if you expect more.",
  };
}
